export default "__VITE_ASSET__CIN1EUfo__"